module.exports = __webpack_public_path__ + "static/media/ohr_hatorah_logo.bc6ad4aa.jpg";